import _defineProperty2 from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, MemoryRouter, Route, Router } from 'react-router-dom';
import { createBrowserHistory, createMemoryHistory } from 'history';
import _ from 'lodash';
import { GlobalizationProvider, TranslatorContext } from '@jutro/locale';
import { log, warning } from '@jutro/logger';
import { AuthProvider, SecureRoute } from '@jutro/auth';
import { routeConfirmationModal, RouteTracker, PageHead } from '@jutro/router';
import { SkipNav, Loader, ModalNextProvider, ToastProvider } from '@jutro/components';
import { ServiceManager } from '@jutro/services';
import { BreakpointTracker } from '@jutro/layout';
import { getConfigValue } from '@jutro/config';
import { DevErrorBoundary } from './DevErrorBoundary';
import { isTest } from './env';
import { MessagesLoader } from './MessagesLoader';
import { LanguagesLoader } from './LanguagesLoader';
function composeErrorBoundary(ErrorBoundary) {
  return function (body) {
    return React.createElement(ErrorBoundary, null, body);
  };
}
export var ApplicationRoot = function (_Component) {
  _inherits(ApplicationRoot, _Component);
  var _super = _createSuper(ApplicationRoot);
  function ApplicationRoot(props) {
    var _this;
    _classCallCheck(this, ApplicationRoot);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getRouterHistory", function () {
      var _this$props = _this.props,
        routerHistory = _this$props.routerHistory,
        routerBasename = _this$props.routerBasename;
      if (routerHistory) {
        return routerHistory;
      }
      if (isTest()) {
        return createMemoryHistory({
          getUserConfirmation: routeConfirmationModal
        });
      }
      return createBrowserHistory({
        basename: routerBasename,
        getUserConfirmation: routeConfirmationModal
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onLanguageChange", function _callee(language) {
      var refreshOnLocaleChange;
      return _regeneratorRuntime().async(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            refreshOnLocaleChange = _this.props.refreshOnLocaleChange;
            if (!refreshOnLocaleChange) {
              _context2.next = 4;
              break;
            }
            window.location.reload();
            return _context2.abrupt("return", {});
          case 4:
            _this.setState(function (state) {
              return {
                currentLanguage: language,
                localeLoaded: state.localeLoaded && state.currentLanguage === language
              };
            });
            return _context2.abrupt("return", undefined);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, null, null, null, Promise);
    });
    _defineProperty(_assertThisInitialized(_this), "onLoadMessages", function (messages) {
      _this.setState({
        localeLoaded: true,
        messages: messages
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onLoadLanguages", function () {
      _this.setState({
        languagesLoaded: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderWithRouter", function (children) {
      var _this$props2 = _this.props,
        RouterProp = _this$props2.Router,
        routerBasename = _this$props2.routerBasename;
      if (RouterProp) {
        return React.createElement(RouterProp, {
          basename: routerBasename,
          getUserConfirmation: routeConfirmationModal
        }, children);
      }
      return React.createElement(Router, {
        history: _this.routerHistory,
        basename: routerBasename
      }, children);
    });
    _defineProperty(_assertThisInitialized(_this), "renderRequiredComponents", function () {
      var _this$props3 = _this.props,
        trackingCallback = _this$props3.trackingCallback,
        _this$props3$modalPro = _this$props3.modalProviderId,
        modalProviderId = _this$props3$modalPro === void 0 ? 'modalProvider' : _this$props3$modalPro,
        disableModalProvider = _this$props3.disableModalProvider;
      return React.createElement(React.Fragment, null, React.createElement(RouteTracker, {
        track: trackingCallback
      }), React.createElement(ToastProvider, null), !disableModalProvider && React.createElement(ModalNextProvider, {
        id: modalProviderId
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderPageHead", function (translator) {
      return React.createElement(PageHead, {
        currentLanguage: _this.state.currentLanguage,
        appName: translator(_this.props.appName),
        appDescription: translator(_this.props.appName)
      });
    });
    var localeService = ServiceManager.getService('locale');
    var currentLocale = localStorage.selectedLocale || localeService.getCurrentLocale();
    var currentLanguage = localStorage.selectedLanguage || localeService.getCurrentLanguage();
    _this.state = {
      currentLocale: currentLocale,
      currentLanguage: currentLanguage,
      localeLoaded: false,
      languagesLoaded: false,
      messages: {}
    };
    _this.routerHistory = _this.getRouterHistory();
    _this.authEnabled = getConfigValue('JUTRO_AUTH_ENABLED', false);
    return _this;
  }
  _createClass(ApplicationRoot, [{
    key: "getHOCs",
    value: function getHOCs() {
      var _this$props4 = this.props,
        errorBoundary = _this$props4.errorBoundary,
        rootHOCs = _this$props4.rootHOCs;
      var hocs = [];
      if (rootHOCs) {
        if (_.isArray(rootHOCs)) {
          hocs = _toConsumableArray(rootHOCs);
        } else {
          hocs.push(rootHOCs);
        }
      }
      hocs.push(composeErrorBoundary(errorBoundary));
      return hocs;
    }
  }, {
    key: "applyHOCs",
    value: function applyHOCs(body) {
      var _context;
      return _reduceInstanceProperty(_context = this.getHOCs()).call(_context, function (jsx, hocFunc) {
        if (_.isFunction(hocFunc)) {
          return hocFunc(jsx);
        }
        log.warning('rootHOC is not a function. HOC will not be applied');
        return jsx;
      }, body);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        currentLocale = _this$state.currentLocale,
        localeLoaded = _this$state.localeLoaded,
        languagesLoaded = _this$state.languagesLoaded,
        messages = _this$state.messages,
        currentLanguage = _this$state.currentLanguage;
      var _this$props5 = this.props,
        Main = _this$props5.main,
        onAuthSessionExpired = _this$props5.onAuthSessionExpired,
        messageLoader = _this$props5.messageLoader,
        coreMessageLoader = _this$props5.coreMessageLoader,
        intlTextComponent = _this$props5.intlTextComponent;
      var renderMain = function renderMain(routeProps) {
        return React.createElement(React.Fragment, null, _this2.renderRequiredComponents(), React.createElement(Main, _extends({}, routeProps, {
          hasLoaded: localeLoaded
        })));
      };
      var renderBody = function renderBody(_ref) {
        var _ref$isAuthenticated = _ref.isAuthenticated,
          isAuthenticated = _ref$isAuthenticated === void 0 ? true : _ref$isAuthenticated,
          routeProps = _objectWithoutProperties(_ref, ["isAuthenticated"]);
        return React.createElement(GlobalizationProvider, {
          messages: messages,
          defaultLocale: currentLocale,
          onLanguageChange: _this2.onLanguageChange,
          intlTextComponent: intlTextComponent
        }, React.createElement(React.Fragment, null, isAuthenticated && React.createElement(MessagesLoader, {
          messageLoader: messageLoader,
          coreMessageLoader: coreMessageLoader,
          language: currentLanguage,
          onLoad: _this2.onLoadMessages
        }), isAuthenticated && React.createElement(LanguagesLoader, {
          onLoad: _this2.onLoadLanguages
        }), localeLoaded && React.createElement(TranslatorContext.Consumer, null, _this2.renderPageHead), React.createElement(Loader, {
          loaded: isAuthenticated && localeLoaded && languagesLoaded
        }, React.createElement(React.Fragment, null, React.createElement(SkipNav, null), React.createElement(BreakpointTracker, null, renderMain(routeProps))))));
      };
      var routes = this.authEnabled && !this.props.disableAuthForApplicationRoot ? React.createElement(AuthProvider, {
        onAuthSessionExpired: onAuthSessionExpired
      }, React.createElement(SecureRoute, {
        path: "/",
        render: function render(_ref2) {
          var auth = _ref2.auth,
            routeProps = _objectWithoutProperties(_ref2, ["auth"]);
          return renderBody(_objectSpread({
            isAuthenticated: auth.authenticated
          }, routeProps));
        }
      })) : React.createElement(Route, {
        path: "/"
      }, function (routeProps) {
        return renderBody(routeProps);
      });
      return this.applyHOCs(this.renderWithRouter(routes));
    }
  }]);
  return ApplicationRoot;
}(Component);
_defineProperty(ApplicationRoot, "propTypes", {
  messageLoader: PropTypes.func,
  coreMessageLoader: PropTypes.func,
  intlTextComponent: PropTypes.string,
  errorBoundary: PropTypes.func,
  main: PropTypes.func.isRequired,
  trackingCallback: PropTypes.func,
  Router: PropTypes.oneOf([BrowserRouter, MemoryRouter]),
  routerHistory: PropTypes.object,
  routerBasename: PropTypes.string,
  rootHOCs: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
  refreshOnLocaleChange: PropTypes.bool,
  onAuthSessionExpired: PropTypes.func
});
_defineProperty(ApplicationRoot, "defaultProps", {
  messageLoader: function messageLoader(locale) {
    warning("No application specific message resources loaded for locale: ".concat(locale));
    return {};
  },
  coreMessageLoader: function coreMessageLoader(locale) {
    warning("No core message resources loaded for locale: ".concat(locale));
    return {};
  },
  errorBoundary: DevErrorBoundary,
  routerBasename: getConfigValue('JUTRO_ROUTER_BASENAME', ''),
  refreshOnLocaleChange: false
});
ApplicationRoot.__docgenInfo = {
  componentName: "ApplicationRoot",
  packageName: "@jutro/app",
  description: "A root-level component that takes care of application-level\nconcerns for you:\n-- internationalization\n-- routing\n-- error handling (uncaught)\nIf the application requires a custom HOC, rootHOCs render prop\ncan be used, e.g. <ApplicationRoot rootHOCs={composeRedux(store)} />.\nArray of HOCs are applied in order starting with first to last and then\nErrorBoundary is added.",
  displayName: "ApplicationRoot",
  methods: [{
    name: "getRouterHistory",
    docblock: "If the router history prop is provided, use it. Otherwise\ndefault to the memory router for test, or browser router for all other cases\n\n@returns {object} - The router history to use",
    modifiers: [],
    params: [],
    returns: {
      description: "The router history to use",
      type: {
        name: "object"
      }
    },
    description: "If the router history prop is provided, use it. Otherwise\ndefault to the memory router for test, or browser router for all other cases"
  }, {
    name: "onLanguageChange",
    docblock: "Refreshes the browser if the option is enabled.\nOtherwise loads the new messages, and sets the language\n\n@param {string} language - the new language\n\n@returns {object} - Newly loaded messages",
    modifiers: ["async"],
    params: [{
      name: "language",
      description: "the new language",
      type: {
        name: "string"
      },
      optional: false
    }],
    returns: {
      description: "Newly loaded messages",
      type: {
        name: "object"
      }
    },
    description: "Refreshes the browser if the option is enabled.\nOtherwise loads the new messages, and sets the language"
  }, {
    name: "onLoadMessages",
    docblock: null,
    modifiers: [],
    params: [{
      name: "messages",
      optional: undefined,
      type: null
    }],
    returns: null
  }, {
    name: "onLoadLanguages",
    docblock: null,
    modifiers: [],
    params: [],
    returns: null
  }, {
    name: "getHOCs",
    docblock: "Returns an array of higher-order components.\n\n@returns {Array<Function>} - The array of higher-order components",
    modifiers: [],
    params: [],
    returns: {
      description: "The array of higher-order components",
      type: {
        name: "Array",
        elements: [{
          name: "Function"
        }]
      }
    },
    description: "Returns an array of higher-order components."
  }, {
    name: "renderWithRouter",
    docblock: "Render the children with the correct router. If a custom Router prop is present\nuse it as the router. Otherwise use the base React Router with a custom history.\n\n@param {React.ReactElement} children - router children to render\n@returns {React.ReactElement} - the rendered router",
    modifiers: [],
    params: [{
      name: "children",
      description: "router children to render",
      type: {
        name: "React.ReactElement"
      },
      optional: false
    }],
    returns: {
      description: "the rendered router",
      type: {
        name: "React.ReactElement"
      }
    },
    description: "Render the children with the correct router. If a custom Router prop is present\nuse it as the router. Otherwise use the base React Router with a custom history."
  }, {
    name: "renderRequiredComponents",
    docblock: "Render any additional components required for Jutro app functionality\n\n@returns {React.ReactElement} - The fragment containing the additional components",
    modifiers: [],
    params: [],
    returns: {
      description: "The fragment containing the additional components",
      type: {
        name: "React.ReactElement"
      }
    },
    description: "Render any additional components required for Jutro app functionality"
  }, {
    name: "applyHOCs",
    docblock: "Applies the HOCs to the body of the application.\n\n@param {React.ReactElement} body - The application body\n@returns {React.ReactElement} - The wrapped application body",
    modifiers: [],
    params: [{
      name: "body",
      description: "The application body",
      type: {
        name: "React.ReactElement"
      },
      optional: false
    }],
    returns: {
      description: "The wrapped application body",
      type: {
        name: "React.ReactElement"
      }
    },
    description: "Applies the HOCs to the body of the application."
  }, {
    name: "renderPageHead",
    docblock: "Renders a react-helmet element that builds a localized titleTemplate and description, and other meta tags.\n\n@param {Function} translator - The localization translator function\n@returns {React.ReactElement} - The Helmet header element",
    modifiers: [],
    params: [{
      name: "translator",
      description: "The localization translator function",
      type: {
        name: "Function"
      },
      optional: false
    }],
    returns: {
      description: "The Helmet header element",
      type: {
        name: "React.ReactElement"
      }
    },
    description: "Renders a react-helmet element that builds a localized titleTemplate and description, and other meta tags."
  }],
  actualName: "ApplicationRoot",
  props: {
    messageLoader: {
      type: {
        name: "func"
      },
      required: false,
      description: "",
      defaultValue: {
        value: "locale => {\n    warning(\n        `No application specific message resources loaded for locale: ${locale}`\n    );\n    return {};\n}",
        computed: false
      }
    },
    coreMessageLoader: {
      type: {
        name: "func"
      },
      required: false,
      description: "",
      defaultValue: {
        value: "locale => {\n    warning(`No core message resources loaded for locale: ${locale}`);\n    return {};\n}",
        computed: false
      }
    },
    intlTextComponent: {
      type: {
        name: "string"
      },
      required: false,
      description: ""
    },
    errorBoundary: {
      type: {
        name: "func"
      },
      required: false,
      description: "",
      defaultValue: {
        value: "DevErrorBoundary",
        computed: true
      }
    },
    main: {
      type: {
        name: "func"
      },
      required: true,
      description: ""
    },
    trackingCallback: {
      type: {
        name: "func"
      },
      required: false,
      description: ""
    },
    Router: {
      type: {
        name: "enum",
        value: [{
          value: "import { BrowserRouter, MemoryRouter, Route, Router } from 'react-router-dom';",
          computed: true
        }, {
          value: "import { BrowserRouter, MemoryRouter, Route, Router } from 'react-router-dom';",
          computed: true
        }]
      },
      required: false,
      description: ""
    },
    routerHistory: {
      type: {
        name: "object"
      },
      required: false,
      description: ""
    },
    routerBasename: {
      type: {
        name: "string"
      },
      required: false,
      description: "",
      defaultValue: {
        value: "getConfigValue('JUTRO_ROUTER_BASENAME', '')",
        computed: true
      }
    },
    rootHOCs: {
      type: {
        name: "union",
        value: [{
          name: "func"
        }, {
          name: "arrayOf",
          value: {
            name: "func"
          }
        }]
      },
      required: false,
      description: ""
    },
    refreshOnLocaleChange: {
      type: {
        name: "bool"
      },
      required: false,
      description: "",
      defaultValue: {
        value: "false",
        computed: false
      }
    },
    onAuthSessionExpired: {
      type: {
        name: "func"
      },
      required: false,
      description: ""
    }
  }
};